import { Component, inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { MessageService } from 'primeng/api';
import { SelectModule } from 'primeng/select';
import { TextareaModule } from 'primeng/textarea';
import { PartnersWidget } from './partnerswidget';
import { ContactService } from '../services/contact.service';
import { DialogModule } from 'primeng/dialog';



// Define estas Regex fuera de la clase o justo dentro para usarlas
const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
const phoneRegex = /^[0-9]{8,15}$/; // Permite +, números, espacios y guiones. Entre 8 y 15 chars.

@Component({
    selector: 'footer-widget',
    standalone: true,
    providers: [MessageService],
    imports: [
        CommonModule, 
        ReactiveFormsModule, 
        InputTextModule, 
        TextareaModule, 
        SelectModule, 
        ButtonModule,
        DialogModule,
        PartnersWidget
    ],
    template: `
        <div class="gradient-line w-full mt-8"></div>

        <footer id="footer" class="py-4 relative overflow-hidden">

            <partners-widget backgroundColor="#a9a9a9"></partners-widget>

            <div class="grid grid-nogutter pt-4 px-4 lg:px-8" [ngClass]="{'justify-content-center text-center': !showForm}">
                
                <div [class]="showForm ? 'col-12 lg:col-6 pr-0 lg:pr-8 mb-6 lg:mb-0' : 'col-12 lg:col-8 flex flex-column align-items-center mb-6'">
                    
                    <h2 class="font-medium text-4xl md:text-5xl lg:text-6xl text-900 mb-4 mt-0 line-height-1" [style.max-width]="showForm ? '90%' : '100%'">
                        Book a tour and the team will be happy to show you around.
                    </h2>

                    <div class="mb-6">
                        <p class="font-regular text-xl text-900 mb-4">
                            Si estás interesado en alguno de nuestros planes, no dudes en contactarnos.
                        </p>
                        
                        <div class="font-regular text-lg text-900 flex flex-wrap gap-4" 
                             [ngClass]="showForm ? 'align-items-center' : 'align-items-center justify-content-center'">
                            <a href="mailto:hola@usinaco.work" class="text-900 no-underline hover:underline">hola&#64;usinaco.work</a>
                            <a href="https://api.whatsapp.com/send?phone=5491139030084" target="_blank" class="text-900 no-underline hover:underline text-sm flex align-items-center gap-2 cursor-pointer">
                                <i class="pi pi-whatsapp"></i>
                                +54 9 11 3903 0084
                            </a>
                        </div>
                    </div>

                    <div class="flex align-items-center gap-4 mb-6" [ngClass]="{'justify-content-center': !showForm}">
                        <a href="https://www.instagram.com/usinacowork/" target="_blank" class="hover:opacity-70 transition-opacity">
                            <img src="/assets/img/footer/instagram.png" alt="Instagram" class="w-2rem h-2rem" />
                        </a>
                        <a href="https://www.linkedin.com/company/usina-cowork/" target="_blank" class="hover:opacity-70 transition-opacity">
                            <img src="/assets/img/footer/linkedin.png" alt="LinkedIn" class="w-2rem h-2rem" />
                        </a>
                        <a href="https://ar.pinterest.com/usinacowork/" target="_blank" class="hover:opacity-70 transition-opacity">
                            <img src="/assets/img/footer/pinterest.png" alt="Pinterest" class="w-2rem h-2rem" />
                        </a>
                    </div>
                </div>

                @if (showForm) {
                    <div class="col-12 lg:col-6 lg:pl-8 pt-0">
                        <form [formGroup]="contactForm" (ngSubmit)="onSubmit()" class="flex flex-column gap-4 max-w-30rem mx-auto lg:mx-0">
                            <div class="field">
                                <input pInputText formControlName="name" placeholder="Nombre" class="w-full usina-input" />
                                @if (contactForm.get('name')?.invalid && contactForm.get('name')?.touched) {
                                    <small class="text-red-500 block mt-1">El nombre debe tener al menos 3 caracteres.</small>
                                }
                            </div>
                            <div class="field">
                                <input pInputText formControlName="phone" placeholder="Teléfono" class="w-full usina-input" />
                                @if (contactForm.get('phone')?.invalid && contactForm.get('phone')?.touched) {
                                    <small class="text-red-500 block mt-1">Ingresá un teléfono válido   .</small>
                                }
                            </div>
                            <div class="field">
                                <input pInputText formControlName="email" placeholder="Email" class="w-full usina-input" />
                                @if (contactForm.get('email')?.invalid && contactForm.get('email')?.touched) {
                                    <small class="text-red-500 block mt-1">Ingresá un correo electrónico válido.</small>
                                }
                            </div>
                            <div class="field">
                                <textarea pInputTextarea formControlName="message" placeholder="Mensaje" rows="3" class="w-full usina-input resize-none"></textarea>
                                @if (contactForm.get('message')?.invalid && contactForm.get('message')?.touched) {
                                    <small class="text-red-500 block mt-1">El mensaje debe tener al menos 15 caracteres.</small>
                                }
                            </div>
                            <div class="my-2">
                                <button pButton 
                                    type="submit" 
                                    label="Enviar" 
                                    [disabled]="contactForm.invalid || isSubmitting" 
                                    [loading]="isSubmitting"
                                    class="p-button-outlined p-button-rounded border-900 text-900 w-auto px-5 font-medium text-lg">
                                </button>
                            </div>
                        </form>
                    </div>
                }

                <div class="flex flex-column gap-4 md:gap-0 md:flex-row md:justify-content-between md:align-items-baseline mt-6 w-full">
                    <img src="/assets/img/logo-usina.png" alt="Usina Cowork" class="w-10rem " />
                    <span>Todos los derechos reservados ®{{ currentYear }}</span>
                </div>

            </div>
            

        </footer>
        <p-dialog [(visible)]="showSuccessModal" 
                [modal]="true" 
                [closable]="false" 
                [draggable]="false"
                [style]="{ width: '90%', maxWidth: '450px' }" 
                styleClass="border-round-2xl overflow-hidden shadow-4">
            
            <div class="w-full h-1rem" style="background-color: #00ff00;"></div>

            <div class="flex flex-column align-items-center text-center p-5 md:p-6 surface-0">
                
                <div class="flex align-items-center justify-content-center border-circle mb-4" 
                    style="width: 5rem; height: 5rem; background-color: rgba(0, 255, 0, 0.1);">
                    <i class="pi pi-check text-primary" style="font-size: 2.5rem;"></i>
                </div>

                <h3 class="font-heavy text-4xl text-900 mt-0 mb-3">¡Mensaje enviado!</h3>
                
                <p class="font-regular text-lg text-700 mb-5 line-height-3">
                    Gracias por contactarnos. El equipo de Usina revisará tu consulta y te responderá a la brevedad.
                </p>

                <button pButton label="ENTENDIDO" 
                        (click)="showSuccessModal = false" 
                        class="w-full p-button-rounded font-bold text-lg usina-btn-submit">
                </button>

            </div>
        </p-dialog>
    `,
    styles: [`
        /* ... tus estilos del footer ... */
        .font-medium { font-family: "ABCDiatype-Medium", sans-serif; }
        .font-regular { font-family: "ABCDiatype-Regular", sans-serif; }
        footer { background-color: #a9a9a9; }
        :host ::ng-deep .usina-input { background: transparent !important; border: none !important; border-bottom: 1px solid rgba(0,0,0,0.4) !important; border-radius: 0 !important; padding-left: 0 !important; padding-bottom: 10px; font-family: "ABCDiatype-Regular", sans-serif; font-size: 1rem; color: #333; }
        :host ::ng-deep .usina-input:focus { border-bottom-color: #000 !important; box-shadow: none !important; }
        :host ::ng-deep .usina-dropdown { background: transparent !important; border: none !important; border-bottom: 1px solid rgba(0,0,0,0.4) !important; border-radius: 0 !important; }
        :host ::ng-deep .usina-dropdown .p-dropdown-label { padding-left: 0 !important; background: transparent !important; }
        :host ::ng-deep .usina-dropdown:not(.p-disabled).p-focus { box-shadow: none !important; border-bottom-color: #000 !important; }
        :host ::ng-deep button.p-button-outlined { border-color: #00ff00 !important; }
        :host ::ng-deep button.p-button-outlined:hover { background-color: black !important; color: white !important; }

        /* Línea decorativa sólida */
        .gradient-line {
            background: linear-gradient(90deg, #00ff00 0%, #00ff00 100%);
            height: 4px;
        }
    `]
})
export class FooterWidget {
    // NUEVO INPUT: Por defecto se muestra, así no rompe la landing principal
    @Input() showForm: boolean = true; 

    // Dentro de la clase:
    private contactService = inject(ContactService);
    isSubmitting = false;
    showSuccessModal: boolean = false;
    contactForm: FormGroup;
    currentYear = new Date().getFullYear();

    inquiryOptions = [ /* ... */ ];

    constructor(private fb: FormBuilder, private messageService: MessageService) {
        this.contactForm = this.fb.group({
            name: ['', [Validators.required, Validators.minLength(3)]],
            email: ['', [Validators.required, Validators.pattern(emailRegex)]],
            phone: ['', [Validators.required, Validators.pattern(phoneRegex)]],
            message: ['', [Validators.required, Validators.minLength(10)]], // Mínimo 15 caracteres
        });
    }

    onSubmit() {
    if (this.contactForm.invalid) {
        this.contactForm.markAllAsTouched();
        return;
    }

    this.isSubmitting = true;

    // Mapeamos al Payload Universal
    const formValue = this.contactForm.value;
    const payload = {
        name: formValue.name,
        email: formValue.email,
        phone: formValue.phone,
        message: formValue.message
        // sede queda undefined, lo cual es correcto aquí
    };

    this.contactService.submit(payload).subscribe({
        next: () => {
            this.isSubmitting = false;
            this.showSuccessModal = true;
            this.contactForm.reset();
        },
        error: () => {
            this.isSubmitting = false;
            this.messageService.add({
                severity: 'error', 
                summary: 'Error', 
                detail: 'No pudimos enviar el mensaje. Revisa tu conexión.'
            });
        }
    });
}
}